import { OnDestroy, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

const defaultFormatOptions: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
}

@Pipe({
  name: 'localizeNumber',
  pure: false,
  standalone: false,
})
export class LocalizeNumberPipe implements OnDestroy, PipeTransform {
  private locale: string

  private languageChangeSubscription: Subscription

  constructor(private readonly translateService: TranslateService) {
    this.locale = this.translateService.currentLang() ?? 'en'

    this.languageChangeSubscription = translateService.onLangChange.subscribe(change => {
      this.locale = change.lang
    })
  }

  ngOnDestroy(): void {
    this.languageChangeSubscription?.unsubscribe()
  }

  transform(value: unknown, formatOptions?: Intl.NumberFormatOptions, locale?: string): string {
    if (typeof value === 'number') {
      const formatter = new Intl.NumberFormat(locale || this.locale, formatOptions || defaultFormatOptions)
      return formatter.format(value)
    }

    // If the input value is not a number, we ignore it and don't attempt any formatting.
    return `${value}`
  }

  get activeLocale(): string {
    return this.locale
  }
}
